// extracted by mini-css-extract-plugin
module.exports = {"bundles":"Bundles_bundles__iR14u"};